import { render, staticRenderFns } from "./CbsZipper.vue?vue&type=template&id=6ac20e13&scoped=true"
import script from "./CbsZipper.vue?vue&type=script&lang=js"
export * from "./CbsZipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac20e13",
  null
  
)

export default component.exports